<div class="col-lg-12 mb-3">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3 mb-0">
        <span class="col-auto">
          <h2 class="mb-0">Commission Program Tier</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button label=" Clear Filters" (click)="clearTable(dt)" />
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12 p-3">
        <p-table
          #dt
          stripedRows
          scrollHeight="calc(100vh - 310px)"
          responsiveLayout="scroll"
          [value]="commissionProgramTierLists"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [size]="'small'"
          [paginator]="commissionProgramTierLists.length >= 20"
          paginatorStyleClass="paginator-table-inside p-datatable-customers p-head-pad"
          styleClass="table-listing">
          <!-- <ng-template pTemplate="caption">
            
          </ng-template> -->
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th pSortableColumn="CommissionProgramID">
                Commission Program ID
                <p-sortIcon field="CommissionProgramID"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="CommissionProgramID"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="CommissionTierNumber">
                Commission Tier Number
                <p-sortIcon field="CommissionTierNumber"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="CommissionTierNumber"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="CommissionTierDescription">
                Commission Tier Discription
                <p-sortIcon field="CommissionTierDescription"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="CommissionTierDescription"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="FromGPValue">
                From GP Value
                <p-sortIcon field="FromGPValue"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="FromGPValue"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="ToGPValue">
                To GP Value
                <p-sortIcon field="ToGPValue"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="ToGPValue"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="MinimumGPPrecent">
                Minimum GP Percentage
                <p-sortIcon field="MinimumGPPrecent"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="MinimumGPPrecent"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="CommissionPercentage">
                Commission Percentage
                <p-sortIcon field="CommissionPercentage"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="CommissionPercentage"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="CalculateReserve">
                Commission
                <p-sortIcon field="CalculateReserve"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="CalculateReserve"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="ReservePercent">
                Reserve
                <p-sortIcon field="ReservePercent"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="ReservePercent"
                  display="menu"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-commissionProgramTierList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="commissionProgramTierList"
              [pSelectableRowIndex]="rowIndex">
              <td>{{ commissionProgramTierList.CommissionProgramID }}</td>
              <td class="align-right">
                {{
                  commissionProgramTierList.CommissionTierNumber
                    | number: "1.2-2"
                }}
              </td>
              <td>{{ commissionProgramTierList.CommissionTierDescription }}</td>
              <td class="align-right">
                {{ commissionProgramTierList.FromGPValue | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ commissionProgramTierList.ToGPValue | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{
                  commissionProgramTierList.MinimumGPPrecent | number: "1.2-2"
                }}
              </td>
              <td class="align-right">
                {{
                  commissionProgramTierList.CommissionPercentage
                    | number: "1.2-2"
                }}
              </td>
              <td class="align-right">
                {{
                  commissionProgramTierList.CalculateReserve | number: "1.2-2"
                }}
              </td>
              <td class="align-right">
                {{ commissionProgramTierList.ReservePercent | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No commission tier program found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
